import { forwardRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Input } from "./input";
import { cn } from "@/lib/utils";

/* Password field with a show/hide toggle. The eye button sits on the
   trailing edge via CSS logical properties (`end-3`, `pe-10`) so it
   mirrors automatically in RTL (Arabic / Urdu). Visibility state is
   ephemeral — never persisted or logged. */
export const PasswordInput = forwardRef(({ className, ...props }, ref) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const testId = props["data-testid"];
  return (
    <div className="relative">
      <Input ref={ref} {...props} type={show ? "text" : "password"}
        className={cn("pe-10", className)} />
      <button type="button"
        aria-label={show ? t("common.hidePassword") : t("common.showPassword")}
        aria-pressed={show}
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        onClick={() => setShow((s) => !s)}
        className="absolute top-1/2 -translate-y-1/2 end-3 text-slate-400 hover:text-slate-600 focus-visible:outline focus-visible:outline-1 focus-visible:outline-slate-400 transition-colors">
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
